export default __webpack_public_path__ + "soil-800-8a43616862df1d787da4602dc957cd8e.png";